import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Logo } from "../components/Logo";
import { API_URL } from "../data/site";

const inputCls =
  "w-full rounded-xl border border-white/12 bg-[#04120E]/70 px-4 py-3.5 text-sm text-white placeholder:text-emerald-100/35 outline-none focus:border-[#00E676]/60 focus:ring-2 focus:ring-[#00E676]/25 transition-[border-color,box-shadow] duration-300";

export default function AdminLogin({ onLogin }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_URL}/auth/login`, form);
      localStorage.setItem("igreen_admin_token", data.token);
      onLogin(data.user);
      toast.success(`Bem-vindo, ${data.user.name}!`);
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Falha no login. Verifique os dados.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#04120E] px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-3xl border border-[#00E676]/20 bg-[#0B261E]/80 backdrop-blur-md p-8">
        <Logo />
        <h1 className="mt-8 font-heading text-2xl font-bold text-white">Área do licenciado</h1>
        <p className="mt-1.5 text-sm text-emerald-100/50">Entre para ver os seus leads.</p>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <input
            type="email"
            data-testid="admin-email-input"
            placeholder="E-mail"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className={inputCls}
            required
          />
          <input
            type="password"
            data-testid="admin-password-input"
            placeholder="Senha"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className={inputCls}
            required
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-button"
            className="w-full rounded-full bg-[#00E676] hover:bg-[#00C853] disabled:opacity-60 text-[#04120E] font-bold px-6 py-3.5 transition-[background-color,opacity] duration-300"
          >
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
        <a href="/" className="mt-6 block text-center text-xs text-emerald-100/40 hover:text-[#00E676] transition-colors">
          Voltar ao site
        </a>
      </div>
    </div>
  );
}
